export enum AlertType {
  Error = 'ERROR',
  Warning = 'WARNING',
}

export const getAlertType = (alertType: string): AlertType => {
  switch (alertType.toLowerCase()) {
    case AlertType.Error.toString().toLowerCase():
      return AlertType.Error
    case AlertType.Warning.toString().toLowerCase():
      return AlertType.Warning
    default:
      console.warn(`Unknown Alert Type, ${alertType}, falling back to 'error'`)
      return AlertType.Error
  }
}
